export default class Color {
	static get RELATION_TYPE() {
		const RELATION_TYPE = {
			PROJECT: 1,
			MEMBER : 2,
		};

		return RELATION_TYPE;
	}
	
	get isDefaultColor() {
		return this.default_value;
	}
	
	get isProjectColor() {
		return this.type === Color.RELATION_TYPE.PROJECT;
	}
	
	get isMemberColor() {
		return this.type === Color.RELATION_TYPE.MEMBER;
	}
	
	get asStyleRGB() {
		return 'rgb(' + this.red + ',' + this.green + ',' + this.blue + ')';
	}
	
	get asStyleRGBA() {
		return 'rgb(' + this.red + ',' + this.green + ',' + this.blue + ',' + this.alpha + ')';
	}
	
	get asHex() {
		let r_hex = ( "0" + this.red.toString( 16 ) ).slice( -2 );
		let g_hex = ( "0" + this.green.toString( 16 ) ).slice( -2 );
		let b_hex = ( "0" + this.blue.toString( 16 ) ).slice( -2 );
		return '#' + r_hex + g_hex + b_hex;
	}
	
	constructor(params) {
		this.code = params.code;
		this.name = params.name;
		this.type = params.type;
		this.seq = params.seq;
		this.red = params.red;
		this.green = params.green;
		this.blue = params.blue;
		this.alpha = params.alpha;
		this.default_value = params.default_value;
	}
}
